<template>
    <b-modal id="patientPrescribeDetailModal" :title="title" size="md">
        <div class="search user_modal">
            <div class="table_list">
                <div class="detail">
                    <div class="title_sm pt0">
                        <h3 class="tb_title">환자처방 상세</h3>
                    </div>
                    <table class="write">
                        <colgroup>
                            <col width="100">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>처방명</th>
                                <td><span>{{patientPrescribeData.prescribe_nm}}</span></td>
                            </tr>
                            <tr>
                                <th>출전</th>
                                <td><span>{{patientPrescribeData.prescribe_source}}</span></td>
                            </tr>
                            <tr>
                                <th>첩수</th>
                                <td><span>{{patientPrescribeData.prescribe_pack_cnt}} 첩</span></td>
                            </tr>
                            <tr>
                                <th>팩수</th>
                                <td><span>{{patientPrescribeData.packs_cnt}} 팩</span></td>
                            </tr>
                            <tr>
                                <th>팩용량</th>
                                <td><span>{{patientPrescribeData.pack_capacity}} ml</span></td>
                            </tr>
                            <tr>
                                <th>처방구성</th>
                                <td><span>{{patientPrescribeData.prescribe_medicine}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button @click="fn_click_apply()" class="btn btn_md btn_brown">반영</b-button>
            <b-button @click="ok" class="btn btn_md btn_brown">닫기</b-button>
        </template>
    </b-modal>

</template>

<script>
    export default {
        name: 'patientPrescribeDetailModal',
        props: {
            title: String,
            patientPrescribeData : {
                prescribe_nm : '',
                prescribe_source : '',
                prescribe_medicine : '',
                prescribe_pack_cnt : '',
                packs_cnt : '',
                pack_capacity : '',
                item : {}
            }
        },
        methods: {
            fn_click_apply(){
                this.$emit('callback', this.patientPrescribeData.item);
            }          
        },
        data () {
            return {
            }
        }
    }
</script>

<style>

</style>